import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import { Link as ScrollLink } from 'react-scroll';
import classNames from 'classnames';
import _ from 'lodash';
import { noop } from 'helpers/GlobalHelper';
import { getCookie } from 'helpers/Storage';
import { getContentBlackout, isBlackoutError } from 'helpers/auth.blackout';
import { getLocationCookies, getSpoofedLocationCookies } from 'helpers/GeoLocationHelper';
import VideoPlayer from 'components/VideoPlayer';
import { getBaseContentUrl } from 'helpers/ApiHelper';
import {
  getDesignatedMarketingAreaData,
  getPreviewPassLengthFromName,
  getPreviewPassTime,
  getMVPDExpireTime,
  previewPassLogout,
  authMVPDLogout,
  PREVIEW_PASS_60,
  setPreviewPassExpired,
} from 'helpers/AuthHelper';
import { isEpgv2Enabled, previewPassEnabled, tveEnabled } from 'helpers/ConfigHelper';
import { helperGetStaticContentUrl } from 'helpers/RouteHelper';
import { LIVE_PLAYER_BACKGROUND_IMAGE, renderImage } from 'helpers/ImageHelper';
import {
  getChannelBackgroundUrl,
  getContentPosition,
  getDuration,
  getPlayerJs,
  getPlayerState,
  isPreviewPass,
  LIVE,
  PLAYER_REFERENCE_DEFAULT,
  PLAYER_STATES,
  playerHideControls,
  playerPause,
  playerPlay,
  playerRemove,
} from 'helpers/PlayerHelper';
import Loader from 'components/Loader';
import {
  Events,
  getPreviewPassAnalyticsEvents,
  getSegmentLastAnonymousProfileId,
  getSegmentLastKnownProfileId,
  getSegmentMVPDEvents,
  getSegmentOptimizelyString,
  getTealiumPlayerEvents,
  handleAnalytics,
  sortEntitlements,
  TrackEvents as GeneralTrackEvents,
} from '@foxcorp/delta-web-analytics';
import {
  SITE_PLATFORM_MOBILE,
  SITE_PLATFORM_TABLET,
  SITE_PLATFORM_WEB,
  SITE_PLATFORM_WEB_LARGE,
} from 'helpers/BreakpointHelper';
import {
  FOX_WEATHER_NETWORK,
  getAdDebug,
  getAdSiteSection,
  getMVPDCookie,
  getMVPDFromCookie,
  getPrivacyParameterCookie,
  getRequiresAuth,
  LOCAL_CLIP_PAGE_COOKIE_NAME,
} from 'helpers/ContentHelper';
import { differenceInSeconds, msToDate, now } from 'helpers/DateTimeHelper';
import {
  getOptimizelyPlayerExperiments,
  getOptimizelyPreviewPassExperiments,
  getOptimizelyRedesignExperiments,
} from 'helpers/OptimizelyHelper';
import { determineBrowser } from 'components/Header/HeaderHelpers';
import {
  AdBlock,
  AreYouWatching,
  ContentBlackout,
  Countdown,
  ExpiredVod,
  RetryError,
} from './Overlays';
import Timer from './Timer';
import MVPDTimer from './MVPDTimer';
import { getChannelId } from './VideoContainerHelper';

// TODO remove after confirmation of new experiment is valid for CPEWEB-3226
const BREAKPOINTS = {
  [SITE_PLATFORM_WEB_LARGE]: {
    showLoader: true,
    prerollBreakpointName: 'ads_sitesection_override_desktop',
  },
  [SITE_PLATFORM_WEB]: {
    showLoader: true,
    prerollBreakpointName: 'ads_sitesection_override_desktop',
  },
  [SITE_PLATFORM_TABLET]: {
    showLoader: false,
    prerollBreakpointName: 'ads_sitesection_override_tablet',
  },
  [SITE_PLATFORM_MOBILE]: {
    showLoader: false,
    prerollBreakpointName: 'ads_sitesection_override_mobile',
  },
};

class VideoContainer extends Component {
  constructor(props) {
    super(props);
    const { background, isVodUnavailable } = props;

    this.state = {
      activeVideo: null,
      adSiteSection: getAdSiteSection(),
      checkedContentBlackout: false,
      hbaStatus: null,
      isPlayerLoaded: false,
      mvpdExpired: false,
      percentWatched: 0,
      playerLoadingImage: background,
      playerState: null,
      previewPassExpired: false,
      previewPassSignIn: false,
      showCountdown: false,
      showContentBlackout: false,
      showCookiesBlocked: false,
      showExpiredVOD: isVodUnavailable,
      showProviders: false,
      showSearchProviders: false,
      showSignIn: true,
      spoofedGeolation: null,
      token: null,
    };
    this.previewPassLogout = previewPassLogout.bind(this);
    this.authMVPDLogout = authMVPDLogout.bind(this);
    window.aeErrorHandling = this.accessEnablerAdvancedErrorHandler;
  }

  componentDidMount() {
    const spoofedGeolation = getSpoofedLocationCookies();

    this.setState({ spoofedGeolation });
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { countdownVideo, isVodUnavailable, videoId, playerReference } = this.props;
    const {
      background,
      isVodUnavailable: nextisVodUnavailable,
      videoId: nextVideoId,
      countdownVideo: nextCountdownVideo,
    } = nextProps;

    const nextState = {};

    if (nextVideoId && nextVideoId !== videoId) {
      nextState.playerLoadingImage = background;
    }
    if (nextisVodUnavailable !== isVodUnavailable) {
      nextState.showExpiredVOD = nextisVodUnavailable;
    }
    if (nextCountdownVideo !== countdownVideo) {
      if (!_.isEmpty(nextCountdownVideo)) {
        nextState.showCountdown = false;
      } else {
        nextState.showCountdown = false;
        playerPlay(playerReference);
      }
    }

    if (!_.isEmpty(nextState)) {
      this.setState(nextState);
    }
  }

  shouldComponentUpdate(nextProps) {
    const { guid, liveNow, waitToRenderPlayer } = this.props;
    const {
      guid: nextGuid,
      liveNow: nextLiveNow,
      mode: nextMode,
      waitToRenderPlayer: nextWaitToRenderPlayer,
    } = nextProps;
    // Block Video Container From Re-rendering when Live status changes
    if (
      nextMode === LIVE &&
      guid === nextGuid &&
      liveNow !== nextLiveNow &&
      waitToRenderPlayer === nextWaitToRenderPlayer
    ) {
      return false;
    }
    return true;
  }

  componentDidUpdate(lastProps, lastState) {
    const { isPlayerLoaded: previousIsPlayerLoaded } = lastState;
    const { isPlayerLoaded, checkedContentBlackout, showContentBlackout } = this.state;
    const { reducerVideo: prevReducerVideo } = lastProps;
    const { authSuccess, reducerVideo, setIsPlayerLoaded } = this.props;
    if (isPlayerLoaded !== previousIsPlayerLoaded) setIsPlayerLoaded(isPlayerLoaded);

    const reducerVideoId = _.get(reducerVideo, 'id');
    const prevReducerVideoId = _.get(prevReducerVideo, 'id');
    const reducerVideoChanged =
      prevReducerVideoId && reducerVideoId && reducerVideoId !== prevReducerVideoId;
    const reducerVideoInitialized = !prevReducerVideoId && reducerVideoId;
    const recheckBlackout = reducerVideoChanged && authSuccess;
    const checkInitialBlackout = !checkedContentBlackout && reducerVideoInitialized && authSuccess;

    if (reducerVideoChanged && showContentBlackout) this.setState({ showContentBlackout: false });
    if (checkInitialBlackout || recheckBlackout) {
      this.setState({ checkedContentBlackout: true });
      this.checkContentBlackout();
    }
  }

  componentWillUnmount() {
    const { setIsPlayerLoaded } = this.props;
    setIsPlayerLoaded(false);
  }

  onShowProvidersCallback = ({ show, keepVideoPaused = true } = {}) => {
    const { playerReference } = this.props;
    this.setState({ showProviders: show, previewPassSignIn: false }, () => {
      const { playerState } = this.state;
      const validStates = [PLAYER_STATES.PLAYING, PLAYER_STATES.AD, PLAYER_STATES.BUFFERING];
      const playVideo = _.indexOf(validStates, playerState) >= 0 && !keepVideoPaused;
      if (playVideo) playerPlay(playerReference);
    });
  };

  onShowSearchProvidersCallback = () => {
    const { showSearchProviders } = this.state;
    this.setState({
      showSearchProviders: !showSearchProviders,
    });
  };

  onCountdownEndRendered = () => {
    const { playerReference } = this.props;
    playerHideControls(playerReference);
  };

  getPercentWatched = () => {
    const { playerReference } = this.props;
    const duration = getDuration(playerReference);
    const position = getContentPosition(playerReference);
    const percentWatched = (position / duration) * 100;

    return percentWatched;
  };

  setIsPlayerLoaded = player => {
    this.setState({ isPlayerLoaded: !!player });
  };

  setToken = ({ token, hbaStatus } = {}) => {
    this.setState({ token, hbaStatus });
  };

  accessEnablerAdvancedErrorHandler = err => {
    const errorId = _.get(err, 'errorId');
    const browser = determineBrowser();
    const isSafari = browser === 'safari';
    const cookiesDisabled = errorId === 'N130';
    const shouldShowCookiesBlocked = cookiesDisabled && isSafari;
    if (shouldShowCookiesBlocked) {
      this.setState({ showCookiesBlocked: true });
    }
  };

  checkContentBlackout = async () => {
    const {
      blackoutConfig,
      blackoutDefinitions,
      deviceId,
      dma,
      isLive,
      mvpdData,
      network,
      setAuthError,
      reducerVideo,
    } = this.props;
    this.setState({ checkedContentBlackout: true });
    try {
      const cableProviderId = _.get(mvpdData, 'metadata.mvpd');
      const zipCode = _.get(mvpdData, 'metadata.zip.0');
      const contentRequiresAuth = getRequiresAuth({ video: reducerVideo });
      const blackoutOptions = {
        blackoutConfig,
        blackoutDefinitions,
        cableProviderId,
        contentRequiresAuth,
        deviceId,
        dma,
        getDesignatedMarketingAreaData,
        isLive,
        network,
        zipCode,
      };
      await getContentBlackout(blackoutOptions);
      console.debug('content blackout not available', zipCode);
    } catch (error) {
      if (isBlackoutError(error)) {
        console.debug('content blackout active');
        const contentBlackoutLanguageOverrides = _.get(error, 'contentBlackoutLanguageOverrides');
        setAuthError(true);
        this.setState({
          showContentBlackout: true,
          contentBlackoutLanguageOverrides,
        });
      } else {
        console.debug('content blackout error', error);
      }
    }
  };

  handleCountdownEnd = () => {
    const { countdownVideo, onChannelSelect } = this.props;
    if (onChannelSelect) {
      this.setState({ showCountdown: false });
      onChannelSelect({ callSign: countdownVideo?.callSign });
    }
  };

  handleExpiration = ({ type }) => {
    const {
      videoId,
      showEndcards,
      handlePopInMiniPlayer,
      isLive,
      playerReference,
      provider,
      account,
      setProvider,
      requiresAuth,
    } = this.props;

    const mvpdId = _.get(provider, 'adobePassId');
    const setStateCallback = () => {
      const profileId = _.get(account, 'profileId');
      const previewPassEvents = getPreviewPassAnalyticsEvents({
        previewPassLength: getPreviewPassLengthFromName(mvpdId),
        profileId,
      });
      const onPreviewPassExpired = _.get(
        previewPassEvents,
        GeneralTrackEvents.PREVIEW_PASS_EXPIRED,
        _.noop,
      );
      onPreviewPassExpired();

      const previewPassLength = mvpdId === PREVIEW_PASS_60 ? 60 : 5;
      getSegmentMVPDEvents().mvpdPreviewPassExpired({
        page_preview_pass_length: previewPassLength,
      });

      if (!isLive) {
        showEndcards(false);
      }
      setProvider(null);
      if (requiresAuth) {
        playerRemove(playerReference);
      } else {
        playerPause(playerReference);
      }
    };

    if (type === 'MVPD') {
      this.previewPassLogout();
      const disableDuplicateOverlay = _.get(
        getOptimizelyRedesignExperiments(),
        'disableDuplicateOverlay',
        false,
      );

      const { videoId, onAuthCheckComplete } = this.props;
      const newState = {
        activeVideo: videoId,
        mvpdExpired: true,
        percentWatched: this.getPercentWatched(),
        showProviders: true,
        showSignIn: !disableDuplicateOverlay,
      };
      const newStateCallback = () => {
        onAuthCheckComplete({ complete: false, success: false });
        this.setState({ showSignIn: true });
      };

      this.setState(newState, newStateCallback);
      if (!isLive) {
        showEndcards(false);
      }
      setProvider(null);
      if (requiresAuth) {
        playerRemove(playerReference);
      } else {
        playerPause(playerReference);
      }
    } else {
      setPreviewPassExpired(true);
      this.previewPassLogout();
      handlePopInMiniPlayer();
      this.setState(
        {
          previewPassExpired: true,
          percentWatched: this.getPercentWatched(),
          activeVideo: videoId,
        },
        setStateCallback,
      );
    }
  };

  handleHover = hover => {
    const { setStickyControls, setPlayerDataHover } = this.props;
    setStickyControls(hover);
    setPlayerDataHover(hover);
  };

  handlePPBannerClick = () => {
    const { onAuthCheckComplete, playerReference } = this.props;
    const playerState = getPlayerState(playerReference);
    const validStates = [PLAYER_STATES.PLAYING, PLAYER_STATES.AD, PLAYER_STATES.BUFFERING];
    if (_.indexOf(validStates, playerState) >= 0) {
      playerPause(playerReference);
    }

    const disableDuplicateOverlay = _.get(
      getOptimizelyRedesignExperiments(),
      'disableDuplicateOverlay',
      false,
    );

    const { videoId, resumeOnCancel } = this.props;
    resumeOnCancel();

    const newState = {
      showProviders: true,
      previewPassSignIn: true,
      percentWatched: this.getPercentWatched(),
      activeVideo: videoId,
      playerState,
      showSignIn: !disableDuplicateOverlay,
    };

    const newStateCallback = () => {
      onAuthCheckComplete({ complete: false, success: false });
      this.setState({ showSignIn: true });
    };

    this.setState(newState, newStateCallback);
  };

  resetShowCookiesBlocked = () => {
    this.setState({ showCookiesBlocked: false });
  };

  renderAuth() {
    const {
      authorizingNetwork,
      background,
      callSign,
      contentNetworks,
      contentRating,
      contentSKU,
      entitlementIssues,
      geoLocationDeclined,
      geoLocationTimeoutFail,
      geoLocationPrimaryActionCallback,
      guid,
      handlePopInMiniPlayer,
      isLive,
      isLiveRestart,
      network,
      releaseURL,
      renderAuthContainer,
      requestSignIn,
      requiresAuth,
      requiresAuthLive,
      resumeWithProfileConfig,
      savePercentWatched,
      selectedChannel,
      setAuthError,
      setPreAuthCheckComplete,
      setVideoOverlay,
      shouldCheckPreviewPass,
      showNoSportsOnMobileError,
      showResumeCTA,
      triggerAuthCheck,
      type,
      videoId,
      videoType,
    } = this.props;
    const {
      mvpdExpired,
      previewPassExpired,
      previewPassSignIn,
      showContentBlackout,
      showCookiesBlocked,
      showProviders,
      showSignIn,
    } = this.state;
    const waitForVideo = !videoId && !releaseURL;
    const channel = getChannelId({ network, authorizingNetwork });
    const playerRelatedAuthProps = {
      authorizingNetwork,
      background,
      callSign,
      channel,
      checkBlackouts: true,
      checkBuythroughScenarios: false,
      contentBlackoutActive: showContentBlackout,
      contentNetworks,
      contentRating,
      contentSKU,
      entitlementIssues,
      geoLocationDeclined,
      geoLocationPrimaryActionCallback,
      geoLocationTimeoutFail,
      getDesignatedMarketingAreaData,
      guid,
      handlePopInMiniPlayer,
      isLive,
      isLiveRestart,
      mvpdExpired,
      network,
      onShowProvidersCallback: this.onShowProvidersCallback,
      previewPassExpired,
      previewPassSignIn,
      releaseURL,
      requestSignIn,
      requiresAuth,
      requiresAuthLive,
      resetShowCookiesBlocked: this.resetShowCookiesBlocked,
      resumeWithProfileConfig,
      savePercentWatched,
      selectedChannel,
      setAuthError,
      setPreAuthCheckComplete,
      setToken: this.setToken,
      setVideoOverlay,
      shouldCheckPreviewPass,
      showCookiesBlocked,
      showNoSportsOnMobileError,
      showProviders,
      showResumeCTA,
      showSignIn,
      triggerAuthCheck,
      type,
      videoId,
      videoType,
      waitForUpsell: false,
      waitForVideo,
    };

    return renderAuthContainer(playerRelatedAuthProps);
  }

  renderContentBlackout = () => {
    const { background, channel } = this.props;
    const { contentBlackoutLanguageOverrides, showContentBlackout } = this.state;
    const backgroundUrl = background || getChannelBackgroundUrl(channel);
    const titleId = _.get(contentBlackoutLanguageOverrides, 'title');
    const messageId = _.get(contentBlackoutLanguageOverrides, 'message');
    const defaultTitle = _.get(window.Language, 'blackout_default_title');
    const defaultMessage = _.get(window.Language, 'blackout_default');
    const title = _.get(window.Language, titleId, defaultTitle);
    const message = _.get(window.Language, messageId, defaultMessage);

    if (!showContentBlackout) return null;

    return <ContentBlackout background={backgroundUrl} title={title} message={message} />;
  };

  renderExpiredVOD = () => {
    const { background, channel } = this.props;
    const { showExpiredVOD } = this.state;
    const backgroundUrl = background || getChannelBackgroundUrl(channel);
    const title = _.get(window.Language, 'playback_expiredContentHeader');
    const message = _.get(window.Language, 'playback_expiredContentMessage');

    if (!showExpiredVOD) return null;

    return <ExpiredVod background={backgroundUrl} title={title} message={message} />;
  };

  renderPlayerLoadingImage() {
    const { breakpoint, channel, playerLoading, mode, theme } = this.props;
    const { playerLoadingImage } = this.state;
    const backgroundUrl = playerLoadingImage || getChannelBackgroundUrl(channel);
    const imageTag = renderImage({
      breakpoint,
      className: theme.playerLoadingImage,
      imageType: LIVE_PLAYER_BACKGROUND_IMAGE,
      src: backgroundUrl,
    });

    if (!playerLoading || mode === LIVE) return null;

    return imageTag;
  }

  renderCountdown = () => {
    const { countdownVideo, isMiniPlayerActive } = this.props;
    const { showCountdown } = this.state;
    if (!showCountdown) return null;
    this.onCountdownEndRendered();
    const background = helperGetStaticContentUrl('images', 'fox-countdown-bg.jpg');
    const timeLeft = differenceInSeconds(countdownVideo.startDate, now());

    return (
      <Countdown
        background={background}
        isMiniPlayerActive={isMiniPlayerActive}
        onCountdownEnd={this.handleCountdownEnd}
        timeLeft={timeLeft}
      />
    );
  };

  setMVPDExpiration = mvpdTTL => {
    const {
      displayPrimeTimeMessage,
      isVideoBanner,
      playerLoading,
      provider,
      reducerVideo,
      requestSignIn,
    } = this.props;

    const mvpdId = _.get(provider, 'adobePassId');
    const isLocalClip = getCookie({ name: LOCAL_CLIP_PAGE_COOKIE_NAME });
    const requiresAuth = _.get(reducerVideo, 'requiresAuth', false);
    const requiresAuthLive = _.get(reducerVideo, 'requiresAuthLive', false);
    const cookie = getMVPDCookie();
    if (
      !cookie ||
      (!requiresAuth && !requiresAuthLive) ||
      isPreviewPass(mvpdId) ||
      displayPrimeTimeMessage ||
      (playerLoading && !requestSignIn) ||
      isVideoBanner ||
      isLocalClip
    ) {
      return null;
    }

    return <MVPDTimer unixEndTime={mvpdTTL} expirationCallback={this.handleExpiration} />;
  };

  renderPreviewPassBanner = previewPassTTL => {
    const {
      disablePreviewPassRender,
      displayPrimeTimeMessage,
      isFullscreen,
      isMiniPlayerActive,
      isVideoBanner,
      panelVideo,
      playerLoading,
      provider,
      requestSignIn,
      reducerVideo,
      theme,
    } = this.props;
    const { previewPassExpired, showCountdown } = this.state;
    const mvpdId = _.get(provider, 'adobePassId');
    const ppDate = previewPassTTL ? msToDate(previewPassTTL) : null;
    const validTTL = ppDate ? differenceInSeconds(ppDate, now()) > 0 : false;
    const isFoxWeatherNetwork = panelVideo?.network === FOX_WEATHER_NETWORK;
    const isLocalClip = getCookie({ name: LOCAL_CLIP_PAGE_COOKIE_NAME });
    const {
      preveiwPass_banner_start: bannerStartText,
      preveiwPass_banner_end: bannerEndText,
      preveiwPass_banner_link: bannerLinkText,
    } = window.Language;
    const requiresAuth =
      _.get(reducerVideo, 'requiresAuth', false) || _.get(panelVideo, 'requiresAuth', false);
    const requiresAuthLive =
      _.get(reducerVideo, 'requiresAuthLive', false) ||
      _.get(panelVideo, 'requiresAuthLive', false);

    if (
      (!requiresAuth && !requiresAuthLive) ||
      !previewPassEnabled() ||
      !isPreviewPass(mvpdId) ||
      displayPrimeTimeMessage ||
      (playerLoading && !requestSignIn) ||
      !validTTL ||
      previewPassExpired ||
      disablePreviewPassRender ||
      isVideoBanner ||
      isLocalClip ||
      isFoxWeatherNetwork ||
      showCountdown
    ) {
      return null;
    }
    const { showControls } = this.props;

    const previewPassHoverEnabled = _.get(
      getOptimizelyPreviewPassExperiments(),
      'previewPassHoverActive',
      false,
    );
    const previewPassTransition =
      showControls && !requestSignIn && previewPassHoverEnabled && theme.previewPassTransition;
    const previewPassCopyClasses = classNames([
      previewPassHoverEnabled && theme.previewPassCopyWithHover,
      theme.previewPassCopy,
      isMiniPlayerActive && theme.miniPlayerActive,
    ]);
    const previewPassClasses = classNames([
      theme.previewPass,
      previewPassHoverEnabled && theme.previewPassWithHover,
      isFullscreen && theme.previewPassHideFullscreen,
    ]);
    const previewPassLoginLinkClasses = classNames([
      theme.previewPassLoginLink,
      previewPassHoverEnabled && theme.previewPassLoginLinkWithHover,
    ]);
    return (
      <div
        className={classNames([previewPassClasses, previewPassTransition])}
        onMouseEnter={() => {
          this.handleHover(true);
        }}
      >
        <div className={previewPassCopyClasses}>
          <div className={theme.previewPassText}>
            {bannerStartText}
            <div>
              <Timer
                isMiniPlayerActive={isMiniPlayerActive}
                unixEndTime={previewPassTTL}
                expirationCallback={() => this.handleExpiration({ type: 'PREVIEW_PASS' })}
              />
              {bannerEndText}
            </div>
          </div>
          <span className={previewPassLoginLinkClasses}>
            <Link onClick={this.handlePPBannerClick}>{bannerLinkText}</Link>
            <span className={theme.previewPassLine} />
          </span>
        </div>
      </div>
    );
  };

  renderStillWatching() {
    const { background, channel, showStillWatching, onStillWatchingClose, account } = this.props;
    const backgroundUrl = background || getChannelBackgroundUrl(channel);
    const profileId = _.get(account, 'profileId');

    if (!showStillWatching) return null;

    return (
      <AreYouWatching
        onClose={() => {
          const {
            [GeneralTrackEvents.PLAYER_IDLE_PROMPT_CONFIRM]: onPlayerIdlePromptConfirm,
          } = getTealiumPlayerEvents({ profileId });
          onPlayerIdlePromptConfirm();
          onStillWatchingClose();
          handleAnalytics({
            event: Events.IDLE_PROMPT_ACTION,
            payload: { page_action_type: 'Yes, continue watching' },
          });
        }}
        background={backgroundUrl}
      />
    );
  }

  renderRetryError = () => {
    const { retryErrors, retryFetchVideo } = this.props;
    const statusCode = _.get(retryErrors, 'statusCode');
    const { responseCodes, background, enabled } = _.get(window, 'ExternalConfig.failureRetry');
    if (_.isEmpty(retryErrors) || !responseCodes.includes(statusCode)) return null;

    return (
      <RetryError
        enabled={enabled}
        statusCode={statusCode}
        background={background}
        onRetryClick={retryFetchVideo}
      />
    );
  };

  render() {
    const {
      account,
      adblock,
      anonymousId,
      authorizingNetwork,
      authSuccess,
      backfade,
      background,
      breakpoint,
      channel,
      children,
      containerClass,
      containerId,
      displayPrimeTimeMessage,
      endCards,
      errors,
      hideLoadingText,
      isFullscreen,
      isMiniPlayerActive,
      isStatic,
      isVideoBanner,
      liveContentId,
      liveNow,
      mediaInfo,
      mode,
      mute,
      network,
      panelVideo,
      playerConfig,
      playerLoading,
      playerReference,
      playerType,
      portalRef,
      preauthorizedResources,
      primeTimeMessage,
      primetimeScrollTo,
      profileId,
      profileToken,
      provider,
      optimizelyResults,
      releaseURL,
      removeEventListeners,
      requestSignIn,
      requiresAuth,
      requiresAuthLive,
      scrubbingEnabled,
      selectedVideo,
      showControls,
      showResumeCTA,
      showUpNextToast,
      siteSection,
      theme,
      type,
      videoDetail,
      videoId,
      waitToRenderPlayer,
    } = this.props;
    const profileAnonymous = !account;
    const mvpdId = _.get(provider, 'adobePassId');
    const {
      activeVideo,
      adSiteSection,
      percentWatched,
      previewPassExpired,
      previewPassSignIn,
      spoofedGeolation,
    } = this.state;
    const abTest = getOptimizelyPlayerExperiments();
    // update releaseURL based off the debug panel.
    let playerConfigParams = {};

    const adDebug = getAdDebug();
    const privacyParameter = getPrivacyParameterCookie();
    if (adDebug || adSiteSection || privacyParameter) {
      playerConfigParams = {
        params: {
          ads: {
            siteSection: adSiteSection,
            debugParameter: adDebug,
            privacyParameter,
          },
        },
      };
    }

    if (percentWatched && activeVideo === videoId) {
      playerConfigParams = {
        ...playerConfigParams,
        ...{ percentWatched, activeVideo, mvpdId },
      };
    }
    // if (!account) {
    //   playerConfigParams = {
    //     ...playerConfigParams,
    //     ...{ percentWatched: 0 },
    //   };
    // }
    const mvpd = getMVPDFromCookie();
    const mvpdRights = _.get(window.ExternalConfig, `contentRights.${mvpd}`);
    const mvpdRightsNetwork = _.get(mvpdRights, 'network');
    const zipcode = mvpdRightsNetwork === network ? _.get(mvpdRights, 'zipcode') : null;
    const pcpParams = _.get(playerConfigParams, 'params', {});

    playerConfigParams = {
      ...playerConfigParams,
      params: {
        ...pcpParams,
        abTest,
        page_test_name: (getSegmentOptimizelyString && getSegmentOptimizelyString()) || null,
        zipcode,
      },
    };

    if (optimizelyResults?.siteSection) {
      playerConfigParams.params.ads.siteSection = optimizelyResults.siteSection[breakpoint];
    }

    _.set(playerConfigParams, 'params.ads.publisherId', anonymousId);

    const entitlementList = preauthorizedResources || [];
    entitlementList.sort(sortEntitlements);
    const networkEntitlementList = entitlementList.join(',');
    const baseConfigUrl = getBaseContentUrl();
    const baseUrl =
      baseConfigUrl.substring(baseConfigUrl.length - 1, baseConfigUrl.length) === '/'
        ? baseConfigUrl.substring(0, baseConfigUrl.length - 1)
        : baseConfigUrl;
    _.set(playerConfigParams, 'params.baseUrl', baseUrl);
    const newPlayerConfig = {
      ...playerConfig,
      ...playerConfigParams,
      authorizingNetwork,
      networkEntitlementList,
      mute,
      container: containerId,
    };

    const backgroundUrl = background || getChannelBackgroundUrl(channel);
    const previewPassTTL = getPreviewPassTime();
    const mvpdTTL = getMVPDExpireTime();

    if (adblock) {
      return (
        <div className={theme.container}>
          <AdBlock background={backgroundUrl} />
        </div>
      );
    }

    const { showProviders, token, hbaStatus } = this.state;

    const containerClasses = classNames(
      isFullscreen ? theme.fullscreen : false,
      previewPassExpired ? theme.previewPassExpired : false,
      theme.container,
      containerClass,
      showProviders || showUpNextToast ? theme.hideControls : false,
      theme.redesignCollections,
      endCards ? theme.containsEndCards : false,
      isVideoBanner ? theme.videoBannerContainer : false,
      isEpgv2Enabled() ? theme.resizablePlayer : false,
      isMiniPlayerActive && theme.miniPlayerActive,
    );

    const backfadeClasses = classNames(
      theme.backfade,
      backfade && showControls ? theme.backfadeVisible : null,
    );
    const { showLoader } = BREAKPOINTS[breakpoint];
    const loader = playerLoading && showLoader && <Loader className={theme.loader} />;
    const {
      livePlayer_preprimetimeButton: preprimetimeButtonText,
      livePlayer_preprimetimeText: preprimetimeText,
      livePlayer_loadingText: loadingText,
    } = window.Language;
    const loaderBackgroundStyle = {
      backgroundImage: backgroundUrl ? `url('${backgroundUrl}')` : null,
    };
    let channelLoaderComponent = null;

    if (displayPrimeTimeMessage) {
      channelLoaderComponent = (
        <span
          className={classNames(theme.noVideoBackground, theme.loaderBackground)}
          style={loaderBackgroundStyle}
        >
          <div className={theme.preprimetimeText}>{primeTimeMessage || preprimetimeText}</div>
          <ScrollLink className={theme.preprimetimeButton} to={primetimeScrollTo} smooth>
            {preprimetimeButtonText}
          </ScrollLink>
        </span>
      );
    } else if (selectedVideo && playerLoading) {
      channelLoaderComponent = (
        <span className={theme.loaderBackground} style={loaderBackgroundStyle}>
          {!hideLoadingText && <div className={theme.loaderText}>{loadingText}</div>}
          {loader}
        </span>
      );
    }

    const loaderComponent = (channel && channelLoaderComponent) || loader;

    const delayedReleaseURL = releaseURL;
    let player = null;
    const isTveEnabled = tveEnabled();
    const lastAnonymousProfileId = getSegmentLastAnonymousProfileId();
    const lastKnownProfileId = getSegmentLastKnownProfileId();
    if (!waitToRenderPlayer && !isStatic) {
      player = (
        <VideoPlayer
          errors={errors}
          geolocation={spoofedGeolation || getLocationCookies()}
          hbaStatus={hbaStatus}
          isFullscreen={isFullscreen}
          lastAnonymousProfileId={lastAnonymousProfileId}
          lastKnownProfileId={lastKnownProfileId}
          liveContentId={liveContentId}
          loadPlayerCb={this.setIsPlayerLoaded}
          mediaInfo={mediaInfo}
          mode={mode}
          mvpdId={mvpdId}
          panelVideo={panelVideo}
          playerConfig={newPlayerConfig}
          playerJs={getPlayerJs()}
          playerLoadingImage={background}
          playerReference={playerReference}
          playerType={playerType}
          portalRef={portalRef}
          profileAnonymous={profileAnonymous}
          profileId={profileId}
          profileToken={profileToken}
          releaseURL={delayedReleaseURL}
          removeEventListeners={removeEventListeners}
          requestSignIn={requestSignIn}
          requiresAuth={requiresAuth}
          requiresAuthLive={requiresAuthLive}
          scrubbingEnabled={scrubbingEnabled}
          showResumeCTA={showResumeCTA}
          token={token}
          tveEnabled={isTveEnabled}
          type={type}
          videoId={videoId}
        />
      );

      if (!waitToRenderPlayer && children) {
        player = React.Children.map(children, child =>
          React.cloneElement(child, {
            authSuccess,
            errors,
            externalId: 'dfwvideoplayer',
            geolocation: spoofedGeolation || getLocationCookies(),
            hbaStatus,
            isFullscreen,
            releaseURL: delayedReleaseURL,
            videoId,
            liveContentId,
            lastAnonymousProfileId,
            lastKnownProfileId,
            token,
            mvpdId,
            panelVideo,
            playerJs: getPlayerJs(),
            playerReference,
            playerType,
            requiresAuth,
            requiresAuthLive,
            siteSection,
            type,
            mode,
            liveNow,
            profileAnonymous,
            profileId,
            profileToken,
            playerConfig: newPlayerConfig,
            portalRef,
            mediaInfo,
            playerLoadingImage: background,
            removeEventListeners,
            scrubbingEnabled,
            loadPlayerCb: this.setIsPlayerLoaded,
            requestSignIn,
            showResumeCTA,
            tveEnabled: isTveEnabled,
          }),
        );
      }
    }

    return (
      <>
        <div
          role="region"
          className={containerClasses}
          onMouseEnter={() => {
            this.handleHover(true);
          }}
          onMouseLeave={() => {
            this.handleHover(false);
          }}
        >
          {this.renderAuth()}
          {this.renderContentBlackout()}
          {this.renderCountdown()}
          {this.renderRetryError()}
          {this.renderStillWatching()}
          {this.renderExpiredVOD()}
          {this.renderPlayerLoadingImage()}
          {!previewPassSignIn && this.renderPreviewPassBanner(previewPassTTL)}
          {this.setMVPDExpiration(mvpdTTL)}
          {player}
          {<div className={backfadeClasses} />}
          {loaderComponent}
          {endCards}
        </div>
        {videoDetail}
      </>
    );
  }
}

VideoContainer.defaultProps = {
  account: null,
  adblock: false,
  anonymousId: null,
  authorizingNetwork: null,
  authSuccess: false,
  background: '',
  blackoutConfig: {},
  blackoutDefinitions: {},
  breakpoint: null,
  callSign: null,
  channel: null,
  children: null,
  containerClass: null,
  containerId: null,
  contentNetworks: [],
  contentRating: null,
  contentSKU: null,
  countdownVideo: {},
  deviceId: null,
  disablePreviewPassRender: false,
  displayPrimeTimeMessage: null,
  dma: null,
  endCards: null,
  entitlementIssues: null,
  geoLocationDeclined: null,
  geoLocationPrimaryActionCallback: noop,
  geoLocationTimeoutFail: false,
  guid: null,
  hideLoadingText: false,
  isFullscreen: false,
  isLive: false,
  isLiveRestart: false,
  isStatic: false,
  isVideoBanner: false,
  isVodUnavailable: false,
  liveContentId: null,
  liveNow: false,
  mediaInfo: null,
  mode: null,
  mute: false,
  mvpdData: null,
  network: null,
  onAuthCheckComplete: noop,
  onChannelSelect: noop,
  optimizelyResults: null,
  playerReference: PLAYER_REFERENCE_DEFAULT,
  playerType: '',
  portalRef: '',
  preauthorizedResources: [],
  primeTimeMessage: null,
  primetimeScrollTo: null,
  profileId: null,
  profileToken: null,
  provider: null,
  reducerVideo: {},
  releaseURL: null,
  requestSignIn: false,
  requiresAuth: null,
  requiresAuthLive: null,
  resumeOnCancel: noop,
  resumeWithProfileConfig: null,
  retryErrors: {},
  retryFetchVideo: noop,
  savePercentWatched: noop,
  scrubbingEnabled: null,
  selectedChannel: null,
  selectedVideo: null,
  setAuthError: noop,
  setIsPlayerLoaded: noop,
  setPlayerDataHover: noop,
  setPreAuthCheckComplete: noop,
  setProvider: noop,
  setStickyControls: noop,
  setVideoOverlay: noop,
  shouldCheckPreviewPass: true,
  showControls: false,
  showEndcards: noop,
  showNoSportsOnMobileError: false,
  showResumeCTA: false,
  showUpNextToast: false,
  siteSection: null,
  triggerAuthCheck: false,
  videoDetail: null,
  videoId: null,
  videoType: null,
  waitToRenderPlayer: false,
};

VideoContainer.propTypes = {
  account: PropTypes.shape({}),
  adblock: PropTypes.bool,
  anonymousId: PropTypes.string,
  authorizingNetwork: PropTypes.string,
  authSuccess: PropTypes.bool,
  backfade: PropTypes.bool.isRequired,
  background: PropTypes.string,
  blackoutConfig: PropTypes.shape({}),
  blackoutDefinitions: PropTypes.shape({}),
  breakpoint: PropTypes.string,
  callSign: PropTypes.string,
  channel: PropTypes.string,
  children: PropTypes.node,
  containerClass: PropTypes.string,
  containerId: PropTypes.string,
  contentNetworks: PropTypes.arrayOf(PropTypes.string),
  contentRating: PropTypes.string,
  contentSKU: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, PropTypes.object])),
  countdownVideo: PropTypes.shape({}),
  deviceId: PropTypes.string,
  disablePreviewPassRender: PropTypes.bool,
  displayPrimeTimeMessage: PropTypes.string,
  dma: PropTypes.string,
  endCards: PropTypes.node,
  errors: PropTypes.shape({}),
  entitlementIssues: PropTypes.arrayOf(PropTypes.shape({})),
  geoLocationDeclined: PropTypes.bool,
  geoLocationPrimaryActionCallback: PropTypes.func,
  geoLocationTimeoutFail: PropTypes.bool,
  guid: PropTypes.string,
  handlePopInMiniPlayer: PropTypes.func,
  hideLoadingText: PropTypes.bool,
  isFullscreen: PropTypes.bool,
  isLive: PropTypes.bool,
  isLiveRestart: PropTypes.bool,
  isMiniPlayerActive: PropTypes.bool,
  isStatic: PropTypes.bool,
  isVideoBanner: PropTypes.bool,
  isVodUnavailable: PropTypes.bool,
  liveContentId: PropTypes.string,
  liveNow: PropTypes.bool,
  mediaInfo: PropTypes.shape({}),
  mode: PropTypes.string,
  mute: PropTypes.bool,
  mvpdData: PropTypes.shape({}),
  network: PropTypes.string,
  onAuthCheckComplete: PropTypes.func,
  onChannelSelect: PropTypes.func,
  onStillWatchingClose: PropTypes.func.isRequired,
  optimizelyResults: PropTypes.shape({}),
  panelVideo: PropTypes.shape({}),
  playerConfig: PropTypes.shape({}).isRequired,
  playerLoading: PropTypes.bool.isRequired,
  playerReference: PropTypes.string,
  playerType: PropTypes.string,
  portalRef: PropTypes.string,
  preauthorizedResources: PropTypes.arrayOf(PropTypes.string),
  primeTimeMessage: PropTypes.string,
  primetimeScrollTo: PropTypes.string,
  profileId: PropTypes.string,
  profileToken: PropTypes.string,
  provider: PropTypes.shape({}),
  reducerVideo: PropTypes.shape({}),
  releaseURL: PropTypes.string,
  removeEventListeners: PropTypes.func,
  renderAuthContainer: PropTypes.func.isRequired,
  requestSignIn: PropTypes.bool,
  requiresAuth: PropTypes.bool,
  requiresAuthLive: PropTypes.bool,
  resumeOnCancel: PropTypes.func,
  resumeWithProfileConfig: PropTypes.shape(),
  retryErrors: PropTypes.shape({}),
  retryFetchVideo: PropTypes.func,
  savePercentWatched: PropTypes.func,
  scrubbingEnabled: PropTypes.bool,
  selectedChannel: PropTypes.number,
  selectedVideo: PropTypes.string,
  setAuthError: PropTypes.func,
  setIsPlayerLoaded: PropTypes.func,
  setPlayerDataHover: PropTypes.func,
  setPreAuthCheckComplete: PropTypes.func,
  setProvider: PropTypes.func,
  setStickyControls: PropTypes.func,
  setVideoOverlay: PropTypes.func,
  shouldCheckPreviewPass: PropTypes.bool,
  showControls: PropTypes.bool,
  showEndcards: PropTypes.func,
  showNoSportsOnMobileError: PropTypes.bool,
  showResumeCTA: PropTypes.bool,
  showStillWatching: PropTypes.bool.isRequired,
  showUpNextToast: PropTypes.bool,
  siteSection: PropTypes.string,
  theme: PropTypes.shape({}).isRequired,
  triggerAuthCheck: PropTypes.bool,
  type: PropTypes.string.isRequired,
  videoDetail: PropTypes.shape({}),
  videoId: PropTypes.string,
  videoType: PropTypes.string,
  waitToRenderPlayer: PropTypes.bool,
};

export default VideoContainer;
